
import React, { useEffect } from "react";
import service from "../services/service";
import { Carousel } from "antd";
import { globalStore } from "../stores/globalStore";
import arrowRight from "../assets/Images/img_arrowright_white_a700.svg"
import { useNavigate } from "react-router-dom";

const TopBanner = () => {
    const { landingPageData } = globalStore();
    const navigate = useNavigate();
    
    const topBannerImages = landingPageData?.topBanners?.images || [];
    
    if (!topBannerImages.length) {
        return null;
    }
    
    return (
        <div className="column-1">
            <div className="topBannerMain">
                <div className="carousel-container">
                    <Carousel
                        autoplay
                        autoplaySpeed={3000}
                        dots={{
                            className: "custom-dots",
                        }}
                    >
                        {topBannerImages.map((image, index) => (
                            <div className="sliderImgWrap" key={index}>
                                <img src={image} alt={`banner-${index}`} className="carousel-image" />
                                <div className="overlay-content">
                                    <button className="cta-button" onClick={() => navigate("/productlisting")}>
                                        <span>Shop Now</span>
                                        <img src={arrowRight} className="arrow_right" alt="arrow"/>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        </div>
    );
};

export default TopBanner;